/* =========================================================
   NUTRI APEX — Theme behavior + AJAX cart.
   Chrome is Liquid; this handles motion, UI, and the cart.
   ========================================================= */
(function () {
  'use strict';

  var FREE_SHIP_THRESHOLD = 3000; /* cents — must match the $0 shipping rate condition in Settings */

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function shortTitle(t) {
    return String(t || '').split('—')[0].split(' - ')[0].trim();
  }

  /* ---------- Reveal-on-scroll ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  function observeReveals(root) {
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }
  observeReveals();
  /* Anything injected after load (quiz results, any innerHTML render) must call this, or its
     .reveal elements sit at opacity:0 forever and read as an empty section. */
  window.NAreveal = observeReveals;

  /* ---------- Count-up numerals (landing pages) ---------- */
  var nums = document.querySelectorAll('.lp-num');
  if (nums.length) {
    var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fmt = function (n) { return n.toLocaleString(); };
    if (noMotion) {
      nums.forEach(function (el) { el.textContent = fmt(parseInt(el.dataset.count, 10) || 0); });
    } else {
      nums.forEach(function (el) { el.textContent = '0'; });
      var nio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          nio.unobserve(en.target);
          var el = en.target, target = parseInt(el.dataset.count, 10) || 0, start = null;
          if (!target) { el.textContent = '0'; return; }
          (function step(t) {
            if (start === null) start = t;
            var p = Math.min((t - start) / 1100, 1);
            el.textContent = fmt(Math.round(target * (1 - Math.pow(1 - p, 3))));
            if (p < 1) requestAnimationFrame(step);
          })(performance.now());
        });
      }, { threshold: 0.6 });
      nums.forEach(function (el) { nio.observe(el); });
    }
  }

  /* ---------- Sticky header ---------- */
  var header = document.getElementById('header');
  if (header) window.addEventListener('scroll', function () {
    header.classList.toggle('scrolled', window.scrollY > 12);
  }, { passive: true });

  /* ---------- Mobile menu ---------- */
  var navToggle = document.getElementById('navToggle');
  var mobileNav = document.getElementById('mobileNav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mobileNav.addEventListener('click', function (e) {
      if (e.target.closest('a')) { mobileNav.classList.remove('open'); navToggle.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---------- Cart drawer ---------- */
  function openDrawer() {
    var d = document.getElementById('drawer'), s = document.getElementById('drawerScrim');
    if (d) d.classList.add('open'); if (s) s.classList.add('open');
  }
  function closeDrawer() {
    var d = document.getElementById('drawer'), s = document.getElementById('drawerScrim');
    if (d) d.classList.remove('open'); if (s) s.classList.remove('open');
  }
  var openBtn = document.getElementById('openCart');
  if (openBtn) openBtn.addEventListener('click', function () { openDrawer(); });
  var closeBtn = document.getElementById('closeCart');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  var scrim = document.getElementById('drawerScrim');
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- AJAX cart ---------- */
  var lastCart = null;

  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function addToCart(formData) {
    return fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    lastCart = cart;
    var body = document.getElementById('drawerBody');
    var badge = document.getElementById('drawerBadge');
    var count = document.getElementById('cartCount');
    var totalEl = document.getElementById('drawerTotal');
    var foot = document.getElementById('drawerFoot');
    var shipWrap = document.getElementById('shippingWrap');
    var savingsLine = document.getElementById('savingsLine');
    var freeShipNote = document.getElementById('freeShipNote');
    if (count) count.textContent = cart.item_count;
    if (badge) badge.textContent = cart.item_count;
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="drawer-empty"><div class="empty-art"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 7h14l-1.4 11.2a2 2 0 0 1-2 1.8H8.4a2 2 0 0 1-2-1.8L5 7Z"/><path d="M9 7V5a3 3 0 1 1 6 0v2"/></svg></div>' +
        '<h4>Your bag is quietly empty.</h4><p>Start with the formula your routine has been quietly asking for.</p>' +
        '<a href="/pages/quiz" class="btn btn-primary">Take the wellness quiz <span class="arrow">&rarr;</span></a></div>';
      if (foot) foot.style.display = 'none';
      if (shipWrap) shipWrap.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    if (shipWrap) shipWrap.style.display = '';

    body.innerHTML = '<div class="drawer-items">' + cart.items.map(function (item) {
      var isSub = item.selling_plan_allocation;
      var note = isSub
        ? '<span class="note"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-3-6.7L21 8"/><path d="M21 3v5h-5"/></svg> ' + esc(item.selling_plan_allocation.selling_plan.name.replace(', 20% off', '')) + '</span>'
        : '<span class="note one">One-time order</span>';
      var img = item.image ? '<img src="' + item.image + '" alt="' + esc(item.product_title) + '" style="width:100%;height:100%;object-fit:cover;border-radius:12px;">' : '';
      return '<div class="drawer-item" data-key="' + esc(item.key) + '">' +
        '<div class="item-img">' + img + '</div>' +
        '<div class="info"><strong>' + esc(shortTitle(item.product_title)) + '</strong>' + note +
        '<div class="item-meta"><div class="qty-mini">' +
        '<button type="button" data-act="dec" aria-label="Decrease">&minus;</button><span>' + item.quantity + '</span>' +
        '<button type="button" data-act="inc" aria-label="Increase">+</button></div>' +
        '<span class="remove" data-act="remove">Remove</span></div></div>' +
        '<div class="price">' + money(item.final_line_price) + '</div></div>';
    }).join('') + '</div>';

    if (totalEl) totalEl.textContent = money(cart.total_price);

    /* Free-ship progress */
    var shipMsg = document.getElementById('shipMsg');
    var shipFill = document.getElementById('shipFill');
    var shipBar = document.getElementById('shipBar');
    var remaining = Math.max(0, FREE_SHIP_THRESHOLD - cart.total_price);
    var pct = Math.min(100, cart.total_price / FREE_SHIP_THRESHOLD * 100);
    if (shipFill) shipFill.style.width = pct + '%';
    if (shipBar) shipBar.classList.toggle('done', remaining === 0);
    if (shipMsg) {
      shipMsg.classList.toggle('unlocked', remaining === 0);
      shipMsg.innerHTML = remaining === 0
        ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="m5 12 5 5L20 7"/></svg> <strong>Free U.S. shipping unlocked</strong>'
        : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 7h13v10H3z"/><path d="M16 10h4l2 3v4h-6"/></svg> Add <strong>' + money(remaining) + '</strong> more for free shipping';
    }
    if (freeShipNote) freeShipNote.textContent = remaining === 0 ? '· Free shipping' : '';

    /* Savings from subscription discounts (line-level) */
    if (savingsLine) {
      var saved = cart.items.reduce(function (s, i) { return s + ((i.original_line_price || i.final_line_price) - i.final_line_price); }, 0);
      if (saved > 0) {
        savingsLine.style.display = 'flex';
        savingsLine.innerHTML = '<span>You\'re saving</span><span>&minus;' + money(saved) + '</span>';
      } else savingsLine.style.display = 'none';
    }
  }

  function refresh() { return fetchCart().then(renderCart); }

  /* Quantity + remove (event delegation) */
  var drawerBody = document.getElementById('drawerBody');
  if (drawerBody) drawerBody.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]'); if (!btn || !lastCart) return;
    var row = btn.closest('.drawer-item'); if (!row) return;
    var key = row.getAttribute('data-key');
    var item = lastCart.items.filter(function (i) { return i.key === key; })[0]; if (!item) return;
    var act = btn.getAttribute('data-act');
    var qty = act === 'remove' ? 0 : act === 'inc' ? item.quantity + 1 : item.quantity - 1;
    changeLine(key, qty).then(renderCart);
  });

  /* Add-to-cart forms (PDP, bundle, etc.)
     Landing pages opt out with .direct-checkout — they post natively and go
     straight to checkout rather than opening the drawer. */
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    if (form.classList.contains('direct-checkout')) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.textContent = 'Adding…'; }
      addToCart(new FormData(form)).then(function (res) {
        if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.label; }
        if (res.ok) { refresh().then(openDrawer); }
        else { alert((res.data && res.data.description) || 'Could not add to bag.'); }
      });
    });
  });

  /* ---------- PDP: pack selector + cadence + button price ----------
     Pack choice swaps which .mode block is live. Hidden blocks get their radios disabled so
     they are never submitted, and the hidden id input follows the chosen variant.
     The Add-to-bag price always reflects the option actually selected. */
  (function () {
    var form = document.getElementById('ProductForm');
    if (!form) return;
    var packGroup = document.getElementById('packGroup');
    var idInput = document.getElementById('variantId');
    var atcPrice = document.getElementById('atcPrice');

    function activeBlock() {
      return form.querySelector('.mode[data-variant]:not([hidden])') || form.querySelector('.mode');
    }

    function paintModes() {
      var block = activeBlock();
      if (!block) return;
      var chosen = block.querySelector('input[name="selling_plan"]:checked');
      block.querySelectorAll('.mode-card').forEach(function (card) {
        card.classList.toggle('active', !!chosen && card.contains(chosen));
      });
      if (atcPrice && chosen && chosen.dataset.price) atcPrice.textContent = chosen.dataset.price;
    }

    function selectPack() {
      var chosen = packGroup.querySelector('input[name="pack"]:checked');
      if (!chosen) return;
      if (idInput) idInput.value = chosen.value;
      packGroup.querySelectorAll('.pack-card').forEach(function (card) {
        card.classList.toggle('is-on', card.contains(chosen));
      });
      form.querySelectorAll('.mode[data-variant]').forEach(function (block) {
        var on = block.dataset.variant === chosen.value;
        block.hidden = !on;
        block.querySelectorAll('input[name="selling_plan"]').forEach(function (i) { i.disabled = !on; });
      });
      form.querySelectorAll('.shipnote[data-variant]').forEach(function (note) {
        note.hidden = note.dataset.variant !== chosen.value;
      });
      paintModes();
    }

    if (packGroup) { packGroup.addEventListener('change', selectPack); selectPack(); }
    form.addEventListener('change', function (e) {
      if (e.target.name === 'selling_plan') paintModes();
    });
    paintModes();
  })();

  /* ---------- Landing page purchase option selector ----------
     One-time vs subscribe, chosen in the buy box rather than discovered at checkout.
     The subscribe radio owns the selling_plan; picking one-time disables that hidden input
     so it is never submitted, which is what makes it a genuine one-time purchase.
     The button label always states what is about to happen. */
  document.querySelectorAll('.lp-plans').forEach(function (group) {
    var form = group.closest('form');
    if (!form) return;
    var planInput = form.querySelector('input[name="selling_plan"]');
    var label = form.querySelector('.lp-buy-label');
    var bigPrice = form.querySelector('.lp-bigprice');

    function apply() {
      var chosen = group.querySelector('input[type="radio"]:checked');
      if (!chosen) return;
      group.querySelectorAll('.lp-plan').forEach(function (opt) {
        opt.classList.toggle('is-on', opt.contains(chosen));
      });
      /* one-time: drop the selling plan entirely */
      if (planInput) planInput.disabled = chosen.value !== 'subscribe';
      if (label && chosen.dataset.cta) label.textContent = chosen.dataset.cta;
      if (bigPrice && chosen.dataset.price) {
        bigPrice.textContent = chosen.dataset.price;
        if (chosen.dataset.priceNote) {
          var note = document.createElement('small');
          note.textContent = chosen.dataset.priceNote;
          bigPrice.appendChild(note);
        }
      }
    }

    group.addEventListener('change', apply);
    apply();
  });

  /* ---------- Then vs Now slider ---------- */
  var stage = document.getElementById('tvnStage');
  var range = document.getElementById('tvnRange');
  if (stage && range) {
    range.addEventListener('input', function (e) { stage.style.setProperty('--pos', e.target.value + '%'); });
    var tvnTabs = document.getElementById('tvnTabs');
    if (tvnTabs) tvnTabs.addEventListener('click', function (e) {
      var btn = e.target.closest('.tvn-tab'); if (!btn) return;
      tvnTabs.querySelectorAll('.tvn-tab').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var pair = (btn.dataset.pair || '').split('|');
      var bt = document.getElementById('tvnBeforeText'), at = document.getElementById('tvnAfterText');
      if (bt && pair[0]) bt.textContent = pair[0].charAt(0).toUpperCase() + pair[0].slice(1);
      if (at && pair[1]) at.textContent = pair[1].charAt(0).toUpperCase() + pair[1].slice(1);
    });
  }

  /* ---------- Accordions ---------- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    if (q) q.addEventListener('click', function () { item.classList.toggle('open'); });
  });
  document.querySelectorAll('.ing').forEach(function (card) {
    card.addEventListener('click', function () { card.classList.toggle('open'); });
  });

  /* Glossary (Science page) */
  (function () {
    var root = document.getElementById('glossGrid'); if (!root) return;
    root.querySelectorAll('.gloss-item').forEach(function (it) { it.addEventListener('click', function () { it.classList.toggle('open'); }); });
    var s = document.getElementById('glossSearch');
    if (s) {
      s.addEventListener('input', function (e) {
        var q = e.target.value.toLowerCase().trim();
        root.querySelectorAll('.gloss-item').forEach(function (el) { el.classList.toggle('hidden', q && el.dataset.term.indexOf(q) === -1); });
      });
      document.addEventListener('keydown', function (e) { if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); s.focus(); } });
    }
  })();

  /* ---------- Testimonial rail arrows ---------- */
  (function () {
    var rail = document.getElementById('ugcRail'); if (!rail) return;
    var wrap = rail.closest('.ugc-rail-wrap'); if (!wrap) return;
    var prev = wrap.querySelector('.ugc-nav.prev'), next = wrap.querySelector('.ugc-nav.next');
    if (!prev || !next) return;
    function stepW() { var c = rail.querySelector('.testimonial'); return c ? c.getBoundingClientRect().width + 16 : 360; }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.classList.toggle('is-disabled', rail.scrollLeft <= 4);
      next.classList.toggle('is-disabled', rail.scrollLeft >= max);
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -stepW(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: stepW(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
  })();

  /* ---------- PDP gallery ---------- */
  (function () {
    var main = document.getElementById('galMain'), track = document.getElementById('galTrack');
    if (!main || !track) return;
    var thumbs = document.getElementById('galThumbs'),
        prev = document.getElementById('galPrev'), next = document.getElementById('galNext'),
        count = document.getElementById('galCount'),
        railPrev = document.getElementById('railPrev'), railNext = document.getElementById('railNext');
    var n = track.querySelectorAll('.gal-slide').length, i = 0;
    if (n < 2) return;

    function go(k) {
      i = Math.max(0, Math.min(k, n - 1));
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      if (count) count.textContent = (i + 1) + ' / ' + n;
      if (prev) prev.classList.toggle('is-disabled', i === 0);
      if (next) next.classList.toggle('is-disabled', i === n - 1);
      /* pause a video we navigated away from */
      track.querySelectorAll('video').forEach(function (v) {
        if (!v.paused && Array.prototype.indexOf.call(track.children, v.closest('.gal-slide')) !== i) v.pause();
      });
      if (!thumbs) return;
      var list = thumbs.querySelectorAll('.gal-thumb');
      list.forEach(function (t, idx) { t.classList.toggle('active', idx === i); });
      var at = list[i];
      if (at) {
        var l = at.offsetLeft, r = l + at.offsetWidth;
        if (l < thumbs.scrollLeft) thumbs.scrollTo({ left: l - 8 });
        else if (r > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollTo({ left: r - thumbs.clientWidth + 8 });
      }
      updateRail();
    }

    function updateRail() {
      if (!railPrev || !thumbs) return;
      var max = thumbs.scrollWidth - thumbs.clientWidth - 2;
      railPrev.classList.toggle('is-disabled', thumbs.scrollLeft <= 4);
      railNext.classList.toggle('is-disabled', max <= 4 || thumbs.scrollLeft >= max);
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.gal-thumb'); if (!t) return;
      go(parseInt(t.dataset.index, 10));
    });
    if (railPrev && railNext && thumbs) {
      railPrev.addEventListener('click', function () { thumbs.scrollBy({ left: -thumbs.clientWidth * 0.8 }); });
      railNext.addEventListener('click', function () { thumbs.scrollBy({ left: thumbs.clientWidth * 0.8 }); });
      thumbs.addEventListener('scroll', updateRail, { passive: true });
      window.addEventListener('resize', updateRail);
    }
    document.addEventListener('keydown', function (e) {
      if (e.target.matches('input,textarea,select')) return;
      if (e.key === 'ArrowLeft') go(i - 1);
      if (e.key === 'ArrowRight') go(i + 1);
    });
    /* swipe */
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
      x0 = y0 = null;
    });

    go(0);
  })();

  /* ---------- Init ---------- */
  refresh();
  window.NAcart = { refresh: refresh, open: openDrawer };
})();
